import React, { useContext } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { ModalAvisoContext } from "../../Context/ModalAvisoContext";
import "./ModalAviso.scss";
const ModalAviso = () => {
  const { isOpen, message, onClosed, toggleModal } = useContext(
    ModalAvisoContext
  );
  return (
    <Modal
      centered={true}
      isOpen={isOpen}
      onClosed={onClosed}
      backdrop="static"
      className="modalAviso"
      size="xl"
    >
      <ModalHeader className="modalAviso__header" toggle={toggleModal}>
        Atenção!
      </ModalHeader>
      <ModalBody className="modalAviso__body">{message}</ModalBody>
    </Modal>
  );
};

export default ModalAviso;
